import { Heart } from "lucide-react";
import { useFavorites } from "@/hooks/useFavorites";

export const FavoriteButton = ({ product, testid }) => {
    const { isFav, toggle } = useFavorites();
    const fav = isFav(product.id);
    return (
        <button
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggle(product);
            }}
            data-testid={testid || `favorite-button-${product.id}`}
            aria-label={fav ? `Remover ${product.name} dos favoritos` : `Salvar ${product.name} nos favoritos`}
            className="absolute left-5 top-5 z-20 flex h-10 w-10 items-center justify-center border border-white/20 bg-forge-ink/80 text-forge-paper backdrop-blur-sm transition-all duration-300 hover:scale-110 hover:border-forge-yellow"
        >
            <Heart className={`h-4 w-4 transition-colors duration-300 ${fav ? "fill-forge-yellow text-forge-yellow" : ""}`} />
        </button>
    );
};

export default FavoriteButton;
